import { render, staticRenderFns } from "./lite.vue?vue&type=template&id=5fcc7cba&scoped=true&"
import script from "./lite.vue?vue&type=script&lang=js&"
export * from "./lite.vue?vue&type=script&lang=js&"
import style0 from "./lite.vue?vue&type=style&index=0&id=5fcc7cba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcc7cba",
  null
  
)

export default component.exports